export const useHistorySelection = (history, selectedIdx, setSelectedIdx) => {
  // selectedHistoryId를 selectedIdx로 변환하는 함수
  const getSelectedHistoryId = () => {
    return history[selectedIdx]?.id || null;
  };

  // selectedIdx를 업데이트하는 함수
  const handleSelectHistory = (historyId) => {
    const idx = history.findIndex(item => item.id === historyId);
    if (idx !== -1) {
      setSelectedIdx(idx);
    }
  };

  return {
    getSelectedHistoryId,
    handleSelectHistory
  };
}; 